import React, { Component } from 'react';
import {
  Flex, FormControl, Input, Select, IconButton, Text, Divider, Button
} from '@chakra-ui/react';
import { MdCalculate, MdCheck, MdClose, MdEdit, MdNote, MdShoppingCart } from 'react-icons/md';
import { User } from '../../store/user/types';
import QuickNumberForm from '../global/forms/QuickNumberForm';

interface QuantityFormProps {
  quantity: number;
  title: string;
  onChange: (quantity: number) => void;
  minLimit?: number;
  maxLimit?: number;
  hideIcon?: boolean;
}

class QuantityForm extends Component<QuantityFormProps> {

  state = {
    quantityFormOpen: false,
  }

  render() {
    const { quantityFormOpen } = this.state;
    let { minLimit, maxLimit } = this.props;
    if (!minLimit) minLimit = 1;
    if (!maxLimit) maxLimit = 1000
    
    return (
      <>
      { quantityFormOpen ? (
        <QuickNumberForm 
          minLimit={minLimit} maxLimit={maxLimit}
          onSubmit={(quantity) => {
            this.props.onChange(quantity)
            this.setState({ quantityFormOpen: false})
          }}
          onClose={() => this.setState({ quantityFormOpen: false})}
          initialNumber={this.props.quantity}
          showLimitText={true}
        />
      ) : (
        <>
        <Flex flexDirection={'row'} align={'center'}>
          {!this.props.hideIcon ? <MdShoppingCart /> : null}
          <Text ml={2}><Button borderRadius={'full'} size={'sm'}>{this.props.quantity}</Button> {this.props.title}</Text>
          <IconButton 
            onClick={() =>this.setState({ quantityFormOpen: true })}
            aria-label='Edit' 
            borderRadius={25} 
            ml={1} 
            variant={'ghost'}
            size={'sm'}
          >
            <MdEdit />
          </IconButton> 
        </Flex>
        </>
      )}
      </>
    )
  }
}

  export default QuantityForm;